export const categories = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-honour-line',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-base-station-line',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shapes-line',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-bear-smile-line',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
  },
];